import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { Transaction, TransactionRequestInterface } from '../../../core';

@Injectable()
export class TransactionRequest extends TransactionRequestInterface {
    wrap<T>(observable: Observable<T>): Observable<Transaction<T>> {
        return observable.pipe(
            switchMap((data) => of(Transaction.success(data))),
            catchError((err: Error) => of(Transaction.error<T>(err.message || null)))
        );
    }
}
